import { CommonModule } from '@angular/common';
import { Component,EventEmitter,Inject,Output } from '@angular/core';
import {
MatLegacyDialogConfig as MatDialogConfig,
MatLegacyDialogModule as MatDialogModule,MatLegacyDialogRef,MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA
} from '@angular/material/legacy-dialog';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import { combineLatest,firstValueFrom,Observable,of } from 'rxjs';
import { map,shareReplay,take } from 'rxjs/operators';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { AccountsReceivableLedgerTypeEnum } from '../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { LedgerImportDocumentTypes } from '../../../dave-data-module/entities/ledger-import.entity';
import { MaterialEntity } from '../../../dave-data-module/entities/material.entity';
import { MaterialToSupplierEntity } from '../../../dave-data-module/entities/materialToSupplier.entity';
import { MaterialGroupResolver } from '../../../dave-data-module/guards/material-group.resolver';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import { MaterialDataService } from '../../../dave-data-module/services/material-data.service';
import { MaterialToSupplierDataService } from '../../../dave-data-module/services/material-to-supplier-data.service';
import { State } from '../../../dave-data-module/State';
import { getCustomerById } from '../../../dave-data-module/State/selectors/customers.selectors';
import {
getMaterialGroupsFetched
} from '../../../dave-data-module/State/selectors/material-group.selectors';
import { getSurchargeRateByArlType,getSurchargeRateFetched } from '../../../dave-data-module/State/selectors/surcharge-rate.selector';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { appMatDialogDefaultConfig } from '../../../helper/helper';
import { MaterialLedgerImportListCardComponent } from '../../../resource-dispo/components/material-ledger-import-list-card/material-ledger-import-list-card.component';
import { MaterialToSupplierListCardComponent } from '../../../resource-dispo/components/material-to-supplier-list-card/material-to-supplier-list-card.component';
import { CustomerDataService } from '../../../dave-data-module/services/customer-data.service';

export interface MaterialPriceDetailsPopupComponentDialogData {
    materialId: number;
    supplierId?: number;
    ledgerImportDocumentType: LedgerImportDocumentTypes.Offer | LedgerImportDocumentTypes.Order | LedgerImportDocumentTypes.DeliveryNote;
    showOtherDocumentType?: boolean;
    showOtherSuppliersList: boolean;
    showAcceptPriceButton?: boolean;
    /**
     * @deprecated use M2SChange Output
     */
    materialEKForm?: FormControl;
    showSupplierButton?: boolean;
    showRemoveButton?: boolean;
}

/**
 * SupplierId
 */
export type MaterialPriceDetailsPopupComponentDialogReturnData = undefined | { supplierId?: number, remove?: boolean };

@Component({
    selector: 'app-material-price-details-popup',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MaterialLedgerImportListCardComponent, MaterialToSupplierListCardComponent, AppButtonModule, FontAwesomeModule, MatLegacyTooltipModule],
    templateUrl: './material-price-details-popup.component.html',
    styleUrls: ['./material-price-details-popup.component.scss'],
})
export class MaterialPriceDetailsPopupComponent {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        minWidth: '40vw',
        maxHeight: '80vh',
    };

    onSelectedPrice(value: MaterialToSupplierEntity) {
        this.M2SChange.emit(value);
        this.dialogRef.close({supplierId: value.SupplierId});
    }

    protected marge$: Observable<number>;
    protected margeFromEntity$: Observable<number>;
    protected defaultSurcharge$: Observable<number>;
    protected sellPrice$: Observable<number>;
    protected cost$: Observable<number>;
    protected costFromMaterial$: Observable<number>;
    protected listPrice$: Observable<number>;
    protected material$: Observable<MaterialEntity>;

    protected cardTitle$: Observable<string>;
    protected otherCardTitle$: Observable<string>;
    protected suppliersLabel$: Observable<string> = this.cls.getMultiple$('Supplier');
    protected suppliersLabelsingular$: Observable<string> = this.cls.getSingle$('Supplier');

    protected ledgerImportDocumentType: LedgerImportDocumentTypes;
    protected ledgerImportOtherDocumentType: LedgerImportDocumentTypes;
    protected materialId: number;
    protected supplierId: number;
    protected showOtherDocumentType: boolean;
    protected showOtherSuppliersList: boolean;
    protected materialEKForm: FormControl;
    protected showSupplierButton: boolean;
    protected showAcceptPriceButton: boolean;
    protected showRemoveButton: boolean;

    protected supplierName$: Observable<string>;

    @Output() M2SChange = new EventEmitter<MaterialToSupplierEntity>();
    @Output() Remove = new EventEmitter<void>();
    constructor(
        private dialogRef: MatLegacyDialogRef<MaterialPriceDetailsPopupComponent, MaterialPriceDetailsPopupComponentDialogReturnData>,
        @Inject(MAT_DIALOG_DATA) data: MaterialPriceDetailsPopupComponentDialogData,
        store: Store<State>,
        materialToSupplierDataService: MaterialToSupplierDataService,
        materialDataService: MaterialDataService,
        materialGroupResolver: MaterialGroupResolver,
        protected cls: CustomLabelService,
        private customerDataService: CustomerDataService
    ) {
        console.log('supplierId: ' + data.supplierId);
        this.ledgerImportDocumentType = data.ledgerImportDocumentType;
        this.ledgerImportOtherDocumentType = data.ledgerImportDocumentType === LedgerImportDocumentTypes.Offer ? LedgerImportDocumentTypes.Order : LedgerImportDocumentTypes.Offer;
        this.materialId = data.materialId;
        this.supplierId = data.supplierId;
        (this.supplierName$ = this.supplierId ? customerDataService.GetSingleCustomer$(this.supplierId).pipe(map((c) => c?.DisplayName || '')) : of('')), (this.showOtherDocumentType = data.showOtherDocumentType);
        this.showOtherSuppliersList = data.showOtherSuppliersList;
        this.materialEKForm = data.materialEKForm;
        this.showSupplierButton = data.showSupplierButton;
        this.showAcceptPriceButton = data.showAcceptPriceButton;
        this.showRemoveButton = !!data.showRemoveButton;

        const m2s$ = materialToSupplierDataService.getMaterialToSupplierByMaterialId$(data.materialId).pipe(map((m2s) => m2s.find((m) => m.SupplierId === data.supplierId)));
        this.material$ = materialDataService.getMaterialById$(data.materialId).pipe(shareReplay({ refCount: true, bufferSize: 1 }));

        this.sellPrice$ = this.material$.pipe(map((material) => (material.SellPrice || 0) / 100));
        this.costFromMaterial$ = this.material$.pipe(map((material) => (material.Cost || 0) / 100));
        this.marge$ = combineLatest([m2s$, this.sellPrice$]).pipe(map(([m2s, sellPrice]) => (sellPrice !== 0 ? (sellPrice - m2s.Cost / 100) / sellPrice : 0)));
        this.margeFromEntity$ = combineLatest([this.material$, this.sellPrice$]).pipe(map(([m, sellPrice]) => (sellPrice !== 0 ? (sellPrice - (m.Cost || 0) / 100) / sellPrice : 0)));
        this.defaultSurcharge$ = getFetched$(store, getSurchargeRateFetched, getSurchargeRateByArlType({ arlType: AccountsReceivableLedgerTypeEnum.MaterialArl })).pipe(map((s) => (s?.PercentageValue || 0) / 100));
        this.cost$ = m2s$.pipe(map((m2c) => (m2c.Cost || 0) / 100));
        this.listPrice$ = m2s$.pipe(map((m2c) => (m2c.ListPrice || 0) / 100));
        // this.title = data.supplierId ? 'Preise des Lieferanten' : 'Preise';
        this.cardTitle$ = this.suppliersLabel$.pipe(
            take(1),
            map((suppliersLabel) => {
                return [data.ledgerImportDocumentType === LedgerImportDocumentTypes.Offer ? 'Angebotshistorie' : 'Bestellhistorie', 'des', data.supplierId ? suppliersLabel : 'Materials'].join(' ');
            }),
        );
        this.otherCardTitle$ = this.suppliersLabel$.pipe(
            take(1),
            map((suppliersLabel) => {
                return this.showOtherDocumentType ? [this.ledgerImportOtherDocumentType === LedgerImportDocumentTypes.Offer ? 'Angebotshistorie' : 'Bestellhistorie', 'des', data.supplierId ? suppliersLabel : 'Materials'].join(' ') : null;
            }),
        );
        firstValueFrom(store.select(getMaterialGroupsFetched)).then((fetched) => {
            if (!fetched) {
                materialGroupResolver.resolve();
            }
        });
    }
}
